import { BarChart3, CheckCircle2, LockKeyhole, ShieldCheck, Store } from "lucide-react";

export function LoginPage() {
  const denied = new URLSearchParams(window.location.search).get("auth") === "denied";
  return <main className="login-page">
    <div className="login-grid" aria-hidden="true" />
    <div className="login-glow login-glow-left" aria-hidden="true" />
    <div className="login-glow login-glow-right" aria-hidden="true" />
    <section className="login-shell" aria-labelledby="login-title">
      <header className="login-brand">
        <img src="https://i.gyazo.com/29aa968686bc11de8a768193c5974484.png" alt="24/7 Chumash North logo" />
        <div><strong>24/7</strong><span>Chumash North</span></div>
      </header>
      <div className="login-card">
        <div className="lock-icon"><LockKeyhole size={22} /></div>
        <span className="eyebrow"><Store size={13} />Private business dashboard</span>
        <h1 id="login-title">Welcome to <span>24/7 Chumash North</span></h1>
        <p>Sign in to view your private sales, product and operational analytics—all built from verified Discord business logs.</p>
        {denied && <div className="login-alert" role="alert">This Discord account is not authorised. Ask the owner to add your Discord User ID.</div>}
        <a className="discord-button" href="/api/auth/login"><svg aria-hidden="true" viewBox="0 0 24 24"><path fill="currentColor" d="M19.5 5.34A16.3 16.3 0 0 0 15.44 4l-.5 1.02a15.3 15.3 0 0 0-5.87 0L8.56 4A16.5 16.5 0 0 0 4.5 5.35C1.93 9.2 1.23 12.95 1.58 16.65a16.6 16.6 0 0 0 4.98 2.52l1.2-1.64a10.7 10.7 0 0 1-1.88-.9l.46-.35c3.63 1.68 7.57 1.68 11.15 0l.47.36c-.6.35-1.23.65-1.89.89l1.2 1.64a16.5 16.5 0 0 0 4.98-2.52c.42-4.28-.72-8-2.75-11.31ZM8.52 14.37c-1.09 0-1.98-1-1.98-2.23s.87-2.23 1.98-2.23 2 1.01 1.98 2.23c0 1.23-.88 2.23-1.98 2.23Zm6.96 0c-1.09 0-1.98-1-1.98-2.23s.87-2.23 1.98-2.23 2 1.01 1.98 2.23c0 1.23-.87 2.23-1.98 2.23Z" /></svg>Continue with Discord</a>
        <div className="login-assurances"><span><CheckCircle2 size={15} />Identity only</span><span><CheckCircle2 size={15} />Secure session</span><span><CheckCircle2 size={15} />No server-wide access</span></div>
      </div>

      <div className="login-highlights" aria-label="Dashboard features">
        <span><BarChart3 size={16} /><strong>Live performance</strong></span>
        <span><ShieldCheck size={16} /><strong>Authorised staff only</strong></span>
        <span><Store size={16} /><strong>Chumash North operations</strong></span>
      </div>
      <p className="login-footnote">24/7 Chumash North · Private business intelligence · Europe/London</p>
    </section>
  </main>;
}
